import { Button } from "reactstrap";
import { Tooltip, Whisper } from "rsuite";

const Required = () => {
  return (
    <Whisper
      trigger="hover"
      placement="autoHorizontal"
      speaker={<Tooltip style={{ width: 120 }}>Required field</Tooltip>}
    >
      <Button
        type="button"
        outline
        color="danger"
        className={`btn-icon-only`}
        style={{ width: "1.2rem", height: "1.2rem" }}
        tabIndex={-1}
      >
        <i
          className="mdi mdi-hexagram"
          style={{ fontSize: 16, lineHeight: 1 }}
        ></i>
      </Button>
    </Whisper>
  );
};

export default Required;
